export const ShareIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="40" viewBox="0 0 40 40" width="40">
    <ellipse cx="20" cy="20" fill="#fff" rx="20" ry="20" transform="matrix(0 -1 1 0 0 40)" />
    <circle cx="20" cy="20" r="14.5" stroke="#292b29" />
    <path
      d="m23.0458 22.1367c-.6289 0-1.2031.2188-1.6406.5742l-2.8164-1.75c.0273-.1367.082-.4101.082-.5742 0-.1367-.0547-.4101-.082-.5469l2.8164-1.75c.4375.3555 1.0117.5469 1.6406.5469 1.4492 0 2.625-1.1484 2.625-2.625 0-1.4492-1.1758-2.625-2.625-2.625-1.4766 0-2.625 1.1758-2.625 2.625 0 .2188 0 .4102.0547.5742l-2.8164 1.75c-.4375-.3554-1.0117-.5742-1.6133-.5742-1.4766 0-2.625 1.1758-2.625 2.625 0 1.4766 1.1484 2.625 2.625 2.625.6016 0 1.1758-.1914 1.6133-.5469l2.8164 1.75c-.0273.1368-.0547.4102-.0547.5469 0 1.4766 1.1484 2.625 2.625 2.625 1.4492 0 2.625-1.1484 2.625-2.625 0-1.4492-1.1758-2.625-2.625-2.625z"
      fill="#292b29"
    />
  </svg>
);
